var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.values),function(value){return _c('base-button',{key:value,staticClass:"col px-3 m-2 btn-secondary",attrs:{"type":_vm.buttonColor(value),"size":"sm","outline":value !== _vm.formData},on:{"click":function($event){_vm.formData = value}}},[_vm._v("\n    "+_vm._s(value)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }